/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Detail_Empty_Filter_Body_AllInputs */



/**
* | output |
* | --- |
* | "This partner has {count} closed periods. Widening a filter brings rows back." |
*
* @param {Partner_Detail_Empty_Filter_Body_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_empty_filter_body_all = /** @type {((inputs: Partner_Detail_Empty_Filter_Body_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Empty_Filter_Body_AllInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieser Partner hat ${i?.count} abgeschlossene Zeiträume. Wenn Sie einen Filter weiter fassen, erscheinen wieder Zeilen.`)
	return /** @type {LocalizedString} */ (`This partner has ${i?.count} closed periods. Widening a filter brings rows back.`)
});